module.exports = __webpack_public_path__ + "img/logo_footer.6710dadd.svg";